import React, {useRef} from 'react';


const useCodeInput = () => {


  // intro, load my design input handler
  let initialValue = new Array(7).fill("");
  const codeInputRefs = useRef([]);
  codeInputRefs.current = initialValue.map((ref, index) => codeInputRefs.current[index] = React.createRef());

  let bespokeCodeTimer;
  const onInputHandler = async (e, index) => {
    e.preventDefault();
    const characterCode = e.target.value.toUpperCase();
    const regexp = /^[A-Za-z0-9]$/;
    const isValid = regexp.test(characterCode);

    if (isValid) {
      codeInputRefs.current[index].current.value = characterCode;
      const nextIdx = index + 1;
      const exIdx = index - 1;

      if (nextIdx <= initialValue.length) {
        codeInputRefs.current[nextIdx] && codeInputRefs.current[nextIdx].current.focus();
        codeInputRefs.current[nextIdx] && codeInputRefs.current[nextIdx].current.select();

        if (exIdx >= 0) {
          codeInputRefs.current[exIdx].current.type = "password";
        }

        if (index === 6) {
          codeInputRefs.current[index-1].current.type = "password";
          bespokeCodeTimer = setTimeout(() => {
            codeInputRefs.current[index].current.type = "password";
          }, 1000);
        }
      }
    }
  }

  const keyDownHandler = async (e, index, enterKeyEvent) => {
    // e.preventDefault();

    const characterCode = String.fromCharCode(e.which);

    if (e.key === 'Backspace') {
      codeInputRefs.current[index].current.value = '';
      codeInputRefs.current[index].current.type = "text";
      if (index > 0) {
        const prevIndex = index - 1;
        codeInputRefs.current[prevIndex].current.type = "text";
        // codeInputRefs.current[prevIndex].current.value = '';
        codeInputRefs.current[prevIndex].current.focus();
        // codeInputRefs.current[prevIndex].current.select();
      }
      return;
    }
    if ((e.ctrlKey || e.metaKey) && characterCode.toLowerCase() === 'v') {
      await pasteFullCode();

      return;
    }

    if(e.key === "ArrowLeft" || e.key === "ArrowRight") {
      let idx;
      if(e.key === "ArrowLeft") {
        idx = index - 1;
      } else if(e.key === "ArrowRight") {
        idx = index + 1;
      }

      if(idx >= 0 && idx < initialValue.length) {
        codeInputRefs.current[idx].current.focus();
      }
    }

    if(index === 6 && e.key === "Enter") {
      if(!enterKeyEvent) {
        return false;
      }
      enterKeyEvent();
    }
  };


  const pasteFullCode = async () => {
    const clipboardText = await navigator.clipboard.readText();
    const regexp = /^[A-Za-z0-9]+$/;
    const isValid = regexp.test(clipboardText);
    if(!isValid) {
      return;
    }
    for (let i = 0; i < initialValue.length; i++) {

      codeInputRefs.current[i].current.focus();
      codeInputRefs.current[i].current.select();
      codeInputRefs.current[i].current.value = String.fromCharCode(clipboardText.charCodeAt(i)).toUpperCase();
    }
  }


  const getEntireCodeFromInput = () => {
    let finalCode = '';
    codeInputRefs.current.map((ref) => {
      finalCode += ref.current.value;
    });
    return finalCode;
  }






  return {
    getEntireCodeFromInput, keyDownHandler, initialValue, codeInputRefs, onInputHandler
  }
}

export default useCodeInput;
